import styled from 'styled-components/macro'
import { spacing, rem, Button, Typography, border, linkReset, themeColor, Color, ColorShade, transitions } from '@unbounded/unbounded-components'

export const Container = styled.div`
  display: flex;
  align-items: center;
`

export const WebsiteLink = styled.a`
  ${linkReset};
  ${Typography.bodyMedium};
  ${Typography.textSemiStrong};
  padding-top: ${rem(6)};
  padding-bottom: ${rem(6)};

  color: ${themeColor(Color.primary)};
  ${transitions(['color'])};

  &:hover,
  &:focus-visible {
    color: ${themeColor(Color.primary, ColorShade.semiStrong)};
  }
`

export const SocialList = styled.div`
  position: relative;
  display: flex;
  align-items: center;

  &:not(:first-child) {
    padding-left: ${spacing(0.75)};
    margin-left: ${spacing()};

    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: ${rem(4)};
      bottom: ${rem(4)};
      border-left: ${border};
    }
  }
`

export const SocialButton = styled(Button).attrs({
  color: 'primary',
  variant: 'transparent',
  size: 'small',
  shape: 'square',
})`
  & + & {
    margin-left: ${spacing(0.25)};
  }
`
